import type { Awareness } from 'y-protocols/awareness';

import { isFeatureFlagEnabled } from '@canvas/client-feature-flags';
import { getExperimentValue } from '@canvas/client-feature-flags/experiments';
import type { AwarenessContainer } from '@canvas/connection';
import { AwarenessChannel } from '@canvas/model/awareness';

export const getAgentParticipantAwarenessForFacepile = (
  awarenessContainer: AwarenessContainer
): Awareness | undefined => {
  // The BE streaming treatment shows agent presence without the facepile gate.
  const isAgentFacepileEnabled =
    isFeatureFlagEnabled('canvasAgentPresenceFacepileFrontend') ||
    getExperimentValue('databaseBEStreaming', 'enabled', {
      fireExperimentExposure: false
    });

  return isAgentFacepileEnabled
    ? awarenessContainer.getAwareness(AwarenessChannel.Participants)
    : undefined;
};
